import { motion } from "framer-motion";

const UTILITIES = [
    { k: "Gas Fees", v: "All Layer-1 transactions metered in $DCX." },
    { k: "Compute Payments", v: "Settle CPU, RAM, container workloads in $DCX." },
    { k: "Storage Payments", v: "Pay for encrypted, erasure-coded storage capacity." },
    { k: "GPU / AI Workloads", v: "Inference, training, and model hosting fees." },
    { k: "Node Staking", v: "Operators bond $DCX to provide infrastructure." },
    { k: "Validator Staking", v: "Secure block production and consensus." },
    { k: "DNS Registration", v: "Pay for on-chain names and resolution." },
    { k: "Governance", v: "On-chain voting over protocol parameters." },
    { k: "Proof of Storage Rewards", v: "Storage nodes earn for verified retention." },
    { k: "Developer Rev Share", v: "Earn protocol-level share of dApp activity, in $DCX." },
    { k: "Protocol Incentives", v: "Bootstrapping and adoption programs." },
    { k: "Ecosystem Grants", v: "Funding for builders, partners, and integrations." },
];

export default function TokenUtility() {
    return (
        <section id="token" className="relative py-24 md:py-32 lg:py-40 border-t border-line" data-testid="token-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl mb-16">
                    <div className="overline mb-4">10 — Token Utility</div>
                    <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl leading-[1.06] tracking-tight text-ink">
                        <span className="brand-gradient-text">$DCX</span> Powers the<br />
                        DeCloudX Infrastructure Economy.
                    </h2>
                    <p className="mt-6 text-base text-muted-ink max-w-2xl leading-relaxed">
                        $DCX is the native gas, settlement, staking, incentive, and governance asset of the DeCloudX network — used by every developer, node operator, validator, and end user touching the protocol.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    {UTILITIES.map((u, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
                            className="surface card-lift p-5 rounded-xl h-full"
                            data-testid={`token-utility-${i}`}
                        >
                            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint-ink">{String(i + 1).padStart(2, "0")}</div>
                            <div className="font-heading font-bold text-ink text-base mt-2">{u.k}</div>
                            <p className="text-xs text-muted-ink mt-2 leading-relaxed">{u.v}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
